import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const toastSuccess=(message:string)=>{
      toast.success(message, {
       position: toast.POSITION.BOTTOM_CENTER,
        style: {
          backgroundColor: "#000",
          color: "#fff",
          borderColor: "transparent",
        },
        autoClose: 1000,
      });
}
export const toastError=(error:string)=>{
    toast.error(error, {
     position: toast.POSITION.BOTTOM_CENTER,
      style: {
        backgroundColor: "#000",
        color: "#fff",
        borderColor: "transparent",
      },
      autoClose: 1000,
    });
}